// LessonSelector.js
import React from 'react';

const LessonSelector = ({ lessons, onSelectLesson }) => (
  <div style={styles.lessonList}>
    <h1>Select a Lesson</h1>
    <ul>
      {lessons.map((lesson) => (
        <li key={lesson.path}>
          <p>
          <button onClick={() => onSelectLesson(lesson)}>
            {lesson.name}
          </button>
          </p>
          <p id="text">
            {lesson.text}
          </p>
        </li>
      ))
}
    </ul>
  </div>
);

    const styles = {
      lessonList : {
        display : 'flex',
        flexDirection : 'column',
        alignItems : 'center',
        width: '100%',
        maxWidth: '500px',
        marginBottom: '20px',
      },
    };

    export default LessonSelector;
